module.exports = __webpack_public_path__ + "static/img/wxgzh.95d3336a.svg";